import template from './travel-expense.html';
import controller from './travel-expense.controller';

let travelExpenseComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default travelExpenseComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/travel-expense/travel-expense.component.js